/**
 * Typography helpers for clean line breaking.
 */

// Non-breaking space (U+00A0), built from its code point to stay unambiguous.
const NBSP = String.fromCharCode(0x00a0);

/**
 * Replace the regular space between a number and a percent sign with a
 * non-breaking space, so a value like "300 %" never wraps with the "%" alone
 * on the next line. Matches Swiss typography (a space between number and unit)
 * while keeping the pair together.
 */
export const protectPercent = (text: string): string => text.replace(/(\d)\s+%/g, `$1${NBSP}%`);
